/* eslint-disable unicorn/consistent-function-scoping */
/* eslint-disable arrow-body-style */
/* eslint-disable react/function-component-definition */
import { Paper } from "@material-ui/core";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";

import { NewIDataUploadItem } from "../../interfaces/IDataUploadItem";
import { RemoveDateFromFileName } from "../../shared/functions";
import Feedback from "../feedback/feedback";
import UploadMultipleFileComponent from "../uploadmultiplefile/UploadMultipleFile";

const resetFileInput = (event: HTMLInputElement) => {
  // eslint-disable-next-line no-param-reassign
  event.type = "text";
  // eslint-disable-next-line no-param-reassign
  event.type = "file";
};

const ConfirmationDialogComment = ({
  open,
  onConfirm,
  onCancel,
  commentChildToParent,
  commentParentToChild,
  action,
}: {
  open: boolean;
  onConfirm?: (data: NewIDataUploadItem[]) => void;
  onCancel?: () => void;
  commentChildToParent;
  commentParentToChild: string;
  action: string;
  // fileBase64Child;
}) => {
  const [isOpen, setIsOpen] = useState(open);
  const [feedbackText, setFeedbackText] = useState("");
  const [feedbackType, setFeedbackType] = useState("");
  const [openFeedback, setOpenFeedback] = useState(false);
  const [errorUploadComment, setErrorUploadComment] = useState(true);
  const [dataUpload, setDataUpload] = useState<NewIDataUploadItem[]>([
    {
      title: "Bukti / Evidence",
      fileType: "Evidence",
      files: [{ documentID: "", fileBase64: "", fileName: "", folderName: "" }],
    },
  ]);
  const [errorUpload, setErrorUpload] = useState("");

  const handleClose = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    setErrorUploadComment(true);
  }, [open]);

  const handleChange = (e) => {
    commentChildToParent(e.target.value);
    if (e.target.value == "") {
      setErrorUploadComment(true);
    } else {
      setErrorUploadComment(false);
    }
  };

  const getBase64 = (file: any) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        resolve(reader.result);
      });
      reader.addEventListener("error", (error) => {
        reject(error);
      });
      reader.readAsDataURL(file);
    });

  const handleChangeUpload = async (data, dataIndex, fileIndex) => {
    if (data != undefined) {
      if (data.name.length > 150) {
        setFeedbackText("File name cannot be more than 150 letters!");
        setFeedbackType("failed");
        setOpenFeedback(true);
        setTimeout(() => {
          setOpenFeedback(false);
        }, 2000);
        return;
      }
      const resultBase64File: any = await getBase64(data).then(
        (bs64: any) => bs64
      );

      const newDataUpload = [...dataUpload];
      const newFileNameWithoutDate = RemoveDateFromFileName(data.name);
      const filteredSameFileName = !newDataUpload.some((item) =>
        item.files.some((file) => {
          const existingFileNameWithoutDate = RemoveDateFromFileName(
            file.fileName
          );
          return existingFileNameWithoutDate === newFileNameWithoutDate;
        })
      );

      if (filteredSameFileName) {
        newDataUpload[dataIndex] = {
          title: newDataUpload[dataIndex].title,
          fileType: newDataUpload[dataIndex].fileType,
          files: [...newDataUpload[dataIndex].files],
        };
        newDataUpload[dataIndex].files[fileIndex] = {
          documentID: "",
          fileBase64: resultBase64File,
          fileName: data.name,
          folderName: "",
        };
        setDataUpload(newDataUpload);
        if (
          newDataUpload[dataIndex].title.includes("*") &&
          newDataUpload[dataIndex].files[fileIndex].fileBase64 != ""
        ) {
          setErrorUpload("");
        }
      } else {
        setFeedbackText("The file already exists, please change the file name");
        setFeedbackType("failed");
        setOpenFeedback(true);
        setTimeout(() => {
          setOpenFeedback(false);
        }, 2000);
      }
    }
  };

  const handleChangeDelete = (dataIndex: number, fileIndex: number) => {
    const newDataUpload = [...dataUpload];
    newDataUpload[dataIndex].files[fileIndex] = {
      documentID: "",
      fileBase64: "",
      fileName: "",
      folderName: "",
    };
    setDataUpload(newDataUpload);
    if (
      newDataUpload[dataIndex].title.includes("*") &&
      newDataUpload[dataIndex].files[fileIndex].fileBase64 == ""
    ) {
      setErrorUpload("Please upload required file");
    }
  };

  const handleChangeDownload = (dataIndex, fileIndex) => {
    const getDataUpload = [...dataUpload];
    const downloadLink = document.createElement("a");
    if (getDataUpload[dataIndex].files[fileIndex].fileBase64 != "") {
      downloadLink.href = getDataUpload[dataIndex].files[fileIndex].fileBase64;
      downloadLink.download =
        getDataUpload[dataIndex].files[fileIndex].fileName;
      downloadLink.click();
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <Paper
        style={{
          width: "600px",
          padding: "25px",
        }}
      >
        <DialogContent>
          <Box
            component="form"
            sx={{
              "& .MuiTextField-root": { width: "100%", marginBottom: "2%" },
            }}
            noValidate
            autoComplete="off"
          >
            <Typography
              variant="subtitle1"
              gutterBottom
              style={{ float: "left" }}
            >
              <u>
                Komentar / <i>Comment</i>
              </u>
              <span style={{ color: "red" }}> *</span>
            </Typography>
            <Typography
              variant="subtitle1"
              gutterBottom
              style={{ float: "right" }}
            >
              {action}
            </Typography>
            <TextField
              multiline
              maxRows={1}
              onChange={(e) => handleChange(e)}
              value={commentParentToChild}
            />
            {errorUploadComment == true && (
              <div className="error-message" style={{ marginBottom: "2%" }}>
                Please input comment
              </div>
            )}
          </Box>
          {/* <Typography variant="subtitle1" gutterBottom>
            <u>
              Bukti / <i>Evidence</i>
            </u>
          </Typography> */}
          {/* <div className="flexbox">
            <div className="chooseFile">
              <label htmlFor="fileComment" className="labelChooseFile">
                Choose File
                <input
                  type="file"
                  name="file"
                  style={{ color: "transparent" }}
                  id="fileComment"
                  onChange={(e) => handleUpload(e)}
                  accept="application/pdf,
                          application/zip,
                          application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                          application/vnd.openxmlformats-officedocument.presentationml.presentation,
                          image/png,
                          image/jpeg,
                          application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                          application/vnd.ms-excel,
                          application/vnd.ms-powerpoint,
                          application/msword"
                />
              </label>
            </div>
            <div className="actionFile">
              <IconButton onClick={handleDownload} sx={{ padding: 0 }}>
                <FileDownloadOutlinedIcon style={{ color: purple[600] }} />
              </IconButton>
              <IconButton onClick={handleDelete} sx={{ padding: 0 }}>
                <DeleteForeverOutlinedIcon style={{ color: purple[600] }} />
              </IconButton>
            </div>
            <div className="lableFile">{fileName}</div>
          </div> */}
          {dataUpload.map((obj, i) => (
            <div>
              <UploadMultipleFileComponent
                file={obj}
                fileIndex={i}
                onUploadFile={(data, fileIndex) => {
                  handleChangeUpload(data, i, fileIndex);
                }}
                onDeleteFile={(fileIndex) => handleChangeDelete(i, fileIndex)}
                onDownloadFile={(fileIndex) => {
                  handleChangeDownload(i, fileIndex);
                }}
                onAddMoreData={() => {
                  if (dataUpload[i].files.length < 5) {
                    setDataUpload((prevState) => {
                      const newState = [...prevState];
                      const emptyFile = {
                        documentID: "",
                        fileBase64: "",
                        fileName: "",
                        folderName: "",
                      };
                      if (i >= 0 && i < newState.length) {
                        newState[i].files.push(emptyFile);
                      }

                      return newState;
                    });
                  }
                }}
                onDeleteData={(ind) => {
                  setDataUpload((prevState) => {
                    const newState = [...prevState];
                    if (
                      i >= 0 &&
                      i < newState.length &&
                      ind >= 0 &&
                      ind < newState[i].files.length
                    ) {
                      newState[i].files.splice(ind, 1);
                    }

                    return newState;
                  });
                }}
                requiredValidationMessage={errorUpload}
              />
            </div>
          ))}
          <Feedback
            open={openFeedback}
            message={feedbackText}
            feedbackType={feedbackType}
          />
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-evenly" }}>
          {onCancel && (
            <Button
              sx={{ background: "#898989", width: "50%" }}
              variant="contained"
              onClick={onCancel}
              color="primary"
            >
              Cancel
            </Button>
          )}
          {onConfirm && (
            <Button
              sx={{ width: "50%" }}
              variant="contained"
              onClick={() => onConfirm(dataUpload)}
              color="primary"
              autoFocus
            >
              OK
            </Button>
          )}
        </DialogActions>
      </Paper>
    </Dialog>
  );
};

export default ConfirmationDialogComment;
